const Decode = () => {
  try {
    return (
      localStorage?.token && JSON.parse(atob(localStorage.token.split('.')[1]))
    );
  } catch {
    localStorage.removeItem('token');
    document.location.assign('/');
  }
  return {};
};

export default Decode;
